import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addToCart } from '../../api/apiStorefront';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useAddToCart = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: addToCart,
    onSuccess: (data) => {
      toast.success(t('cart.addSuccess', 'Product added to cart successfully!'));
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['cart-count'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message || t('cart.addError', 'Failed to add product to cart');
      toast.error(message);
    },
  });
};
